import { Injectable } from '@angular/core';
const BespinSso = require('../../../components/sso/bespinsso');
const bespinsso = new BespinSso(getPortalUrl());

function getPortalUrl() {
    const domainList = window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
    const isDev = domainList[0] === 'alertnowdev' || domainList[0] === 'alertnowdqa';
    console.log(isDev);
    domainList[0] = '';
    const domain = domainList.join('.');

    let portalUrl = '';

    switch (process.env.NODE_ENV) {
        case 'localhost':
            console.log('localhost');
            portalUrl = `https://servicedev${domain}`;
            break;
        case 'dqa':
            console.log('dqa');
            portalUrl = `https://servicedev${domain}`;
            break;
        case 'dev':
            console.log('dev');
            portalUrl = `https://servicedev${domain}`;
            break;
        case 'development':
            console.log('development');
            portalUrl = `https://servicedev${domain}`;
            break;
        case 'kubernetes':
            console.log('kubernetes');
            portalUrl = isDev ? portalUrl = `https://servicedev${domain}` : `https://service${domain}`;
            break;
        case 'prod':
            console.log('prod');
            portalUrl = `https://service${domain}`;
            break;
        case 'prdeks':
        case 'production':
            console.log('production');
            portalUrl = `https://service${domain}`;
            if (domain === '.doosan.com') {
                portalUrl = `https://cloudmpservice${domain}`;
            } else if (domain === '.hyundaimovex.com') {
                portalUrl = `https://cloudservice${domain}`;
            } else if (domain === '.wins21.com') {
                portalUrl   = `https://cloudservice${domain}`;
            } else if (domain === '.sckcorp.co.kr') {
                portalUrl = `https://msp${domain}`;
            } else if (domain === '.spintech.co.kr') {
                portalUrl = `https://msp${domain}`;
            } else if (domain === '.comtec.co.kr') {
                portalUrl = `https://oasis${domain}`;
            }
            break;
        default:
            portalUrl = `https://service${domain}`;
    }
    return portalUrl;
}

@Injectable()
export class KeycloakloginService {
    constructor() {
    };

    init() {
        return bespinsso.init();
    }

    isLoggedIn() {
        return bespinsso.getKeycloak().authenticated;
    }

    getKeycloak() {
        return bespinsso.getKeycloak();
    }

    login() {
        return new Promise((resolve, reject) => {
            // URL에서 idp_hint 파라미터 추출
            const urlParams = new URLSearchParams(window.location.search);
            const idp = urlParams.get('idp_hint');

            // Keycloak 로그인 옵션 설정
            const locale = $.cookie('BSP_LangCode') || 'en';
            const keycloakLoginParams: any = {locale: locale};

            // idp_hint가 있으면 추가
            if (idp) {
                keycloakLoginParams.idpHint = idp;
            }

            bespinsso.getKeycloak().login(keycloakLoginParams);
        });
    }

    logout(options = null) {
        return new Promise((resolve, reject) => {
            bespinsso.getKeycloak().logout(Object.assign({}, options));
        });
    }

    getSessionCount() {
        return bespinsso.getSessionCount();
    }

    logoutAllSession(withoutCurrent = false) {
        return bespinsso.logoutAllSession(withoutCurrent);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/keycloaklogin.service.ts